import { Box, styled } from '@mui/material'
import { StyledIcon } from '../../styles'

export const DraggableIcon = styled(Box)<{ isMobile?: boolean }>(({ theme, isMobile }) => ({
  width: isMobile ? theme.typography.pxToRem(26) : theme.typography.pxToRem(36),
  height: theme.typography.pxToRem(36),
  borderRadius: '3px',
  color: theme.palette.grey[100],
  cursor: 'grab',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  ':hover, :focus-visible': {
    [`${StyledIcon}`]: {
      color: theme.palette.common.white,
    },
  },

  // a11y: keyboard-only white ring (SC 2.4.7). The drag handle is a <div> with no global :focus
  // ring to override on mouse, so :focus-visible only — per the focus-ring rule.
  '&:focus-visible': {
    ...theme.mixins.focusRingOnDark.shadow,
    boxShadow: `${theme.mixins.focusRingOnDark.shadow.boxShadow} !important`,
  },
}))

export const HighlightContainer = styled(Box)<{ isMobile?: boolean }>(({ theme, isMobile }) => ({
  display: 'flex',
  flexDirection: isMobile ? 'row' : 'column',
  backgroundColor: 'var(--bluegrey-800)',
  borderRadius: theme.shape.borderRadius * 1.5,
  padding: theme.spacing(1),
  gap: theme.spacing(1),

  // a11y: white focus ring on mouse + keyboard for the buttons on this dark toolbar;
  // the inherited blue MuiIconButton :focus ring fails 3:1 here (SC 1.4.11)
  '& button:focus, & button:focus-visible': {
    outline: 'none',
    boxShadow: `${theme.mixins.focusRingOnDark.shadow.boxShadow} !important`,
  },
}))
